import type { CSSProperties } from 'react';

export interface ImageSize {
  width?: number;
  height?: number;
}

export interface ImageDetails {
  image?: { width: number; height: number };
}

export interface Format {
  type: string;
  name: FormatName;
}

export interface ContentfulUrlProps {
  fit?: Fit | undefined;
  quality?: number | undefined;
  size: ImageSize;
  bgColor?: string | undefined;
  baseUrl: string;
}

export interface SrcSet {
  srcSet: string;
  type?: string;
  sizes?: string | undefined;
  media?: string;
}

export type Fit = 'crop' | 'scale' | 'pad' | 'fill';

export type FormatName = 'jpg' | 'png' | 'webp' | 'original';

interface CommonImageProps {
  size?: ImageSize;
  style?: Record<string, unknown>;
  imgStyle?: CSSProperties;
  alt?: string;
  className?: string;
  imgClassName?: string;
}

export type ImageProps = CommonImageProps & {
  src: string;
  lowResSrc?: string | undefined;
  srcSets?: Array<SrcSet>;
  aspectRatio?: number;
};
